import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center overflow-hidden bg-bg-main" data-id="element-118">
      {/* Main headline */}
      <h1 className="relative font-serif font-black max-w-5xl text-[38px] leading-[1.1] sm:text-6xl md:text-7xl sm:leading-[1.1] mb-4 sm:mb-6 tracking-tight text-text-main" data-id="element-119">
        Resuelve un año entero de clases de yoga en solo{' '}
        <span className="text-primary italic font-serif" data-id="element-120">5 minutos</span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-sm sm:text-xl font-medium leading-relaxed mb-6 sm:mb-10 max-w-2xl mx-auto text-text-sec" data-id="element-121">
        Más de 1.200 profesoras ya dejaron de improvisar. Llega a cada clase con
        todo listo para enseñar, profundizar y transformar.
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[300px] sm:max-w-[460px] md:max-w-[560px] mx-auto mb-6 sm:mb-10" data-id="element-122">
        <img src="https://cdn.magicpatterns.com/uploads/bR5M9VwcJUzxKr6kzMDgDH/ChatGPT_Image_13_jun_2026,_13_10_06-Photoroom.png" alt="YOGA LISTA — Kit Digital" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(42,92,69,0.15)]" width={500} height={500} fetchPriority="high" loading="eager" decoding="async" data-id="element-123" />
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse font-bold text-base sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-full transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white bg-primary hover:bg-primary-hover shadow-[0_10px_30px_-10px_rgba(42,92,69,0.5)]" data-id="element-124">
        QUIERO EL KIT YOGA LISTA
      </a>

      {/* Trust badges */}
      <p className="text-text-sec text-xs sm:text-sm font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-125">
        <span data-id="element-126">Descarga inmediata</span>
        <span data-id="element-127">·</span>
        <span data-id="element-128">Sin suscripción</span>
        <span data-id="element-129">·</span>
        <span data-id="element-130">Acceso de por vida</span>
      </p>
    </section>;
}